import apiSlice from '../api/api.slice';
import {
  ICreateMakeRequest,
  ICreateMakeResponse,
  IDeleteMakeRequest,
  IDeleteMakeResponse,
  IGetMakesByPostResponse,
} from './projectMake.d';

const projectMakeApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createProjectMake: builder.mutation<
      ICreateMakeResponse,
      ICreateMakeRequest
    >({
      query: (makeData) => ({
        url: `/api/v1/projectMake/create`,
        method: 'POST',
        body: makeData,
      }),
    }),
    deleteProjectMake: builder.mutation<
      IDeleteMakeResponse,
      IDeleteMakeRequest
    >({
      query: ({ makeId }) => ({
        url: `/api/v1/projectMake/${makeId}`,
        method: 'DELETE',
      }),
    }),
    getProjectMakesByPost: builder.query<
      IGetMakesByPostResponse,
      { postId: string }
    >({
      query: ({ postId }) => ({
        url: `/api/v1/projectMake/post/${postId}`,
        method: 'GET',
      }),
      transformResponse: (response: {
        status: string;
        makes: IGetMakesByPostResponse;
      }) => response.makes,
    }),
    getProjectMakesByGroup: builder.query<
      IGetMakesByPostResponse,
      { projectGroupId: string }
    >({
      query: ({ projectGroupId }) => ({
        url: `/api/v1/projectMake/group/${projectGroupId}`,
        method: 'GET',
      }),
      transformResponse: (response: {
        status: string;
        makes: IGetMakesByPostResponse;
      }) => response.makes,
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['ProjectMake', 'Feed', 'UserPosts', 'ProjectGroupList'],
  endpoints: {
    createProjectMake: {
      invalidatesTags: [
        'Post',
        'ProjectMake',
        'Points',
        'ProjectGroup',
        'ProjectGroupList',
        'Feed',
        'UserPosts',
      ],
    },
    deleteProjectMake: {
      invalidatesTags: [
        'Post',
        'ProjectMake',
        'ProjectGroup',
        'ProjectGroupList',
        'Feed',
        'UserPosts',
      ],
    },
    getProjectMakesByPost: {
      providesTags: (result: any) =>
        result
          ? [
              ...result.map(({ _id }: { _id: string }) => ({
                type: 'ProjectMake' as const,
                id: _id,
              })),
              { type: 'ProjectMake' as const, id: 'LIST' },
            ]
          : [{ type: 'ProjectMake' as const, id: 'LIST' }],
    },
    getProjectMakesByGroup: {
      providesTags: (result: any) =>
        result
          ? [
              ...result.map(({ _id }: { _id: string }) => ({
                type: 'ProjectMake' as const,
                id: _id,
              })),
              { type: 'ProjectMake' as const, id: 'LIST' },
            ]
          : [{ type: 'ProjectMake' as const, id: 'LIST' }],
    },
  },
});

export const {
  useCreateProjectMakeMutation,
  useDeleteProjectMakeMutation,
  useGetProjectMakesByPostQuery,
  useGetProjectMakesByGroupQuery,
} = projectMakeApiSlice;
